import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { UserInfo, NotificationInfo } from "../../../context";
import SaveProductUnsave from "./SaveProductUnsave";

const AddProductOrders = ({ close, getProductList, categoryList }) => {
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const [productUnsaveRawList, setProductUnsaveList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [form] = Form.useForm();
  const [inputedQuantityConversion, setInputedQuantityConversion] = useState(0);

  const columns = [
    {
      title: "Product",
      dataIndex: ["productunsaverawproduct", "product"],
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Description",
      dataIndex: ["productunsaverawproduct", "description"],
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["productunsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      align: "right",
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const getRawProductList = useCallback(() => {
    var params = { user_id: userData.data.id, is_production: "all" };
    axios
      .get("user/commissary/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getProductUnsaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/product-unsave-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductUnsaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const handleFetchProduct = (rawID) => {
    var params = {
      raw_id: rawID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/commissary/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getRawProductList();
    getProductUnsaveList();
  }, [getRawProductList, getProductUnsaveList]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductUnsave();
    }, 2000);
  };

  const handleDeleteProductUnsave = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    setLoadings(true);
    axios
      .post("user/commissary/delete-product-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            setLoadings(false);
            getProductUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleAddProductToUnsave = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/new-product-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "product-exist") {
          rerunNotif("error", "Product already added!");
          setTimeout(() => {
            form.setFieldsValue({
              consumption: 0,
            });
            setInputedQuantityConversion(0);
            setLoadings(false);
            setLoading(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "Created new product unsave successfully.");
          setTimeout(() => {
            form.setFieldsValue({
              consumption: 0,
            });
            setInputedQuantityConversion(0);
            setLoadings(false);
            setLoading(false);
            getProductUnsaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button type="primary" icon={<CloseOutlined />} onClick={() => close()}>
          Close
        </Button>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>Creating Product</Typography.Title>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table
                  {...tableProps}
                  pagination={{
                    position: ["bottomCenter"],
                  }}
                  columns={tableColumns}
                  dataSource={
                    productUnsaveRawList.data.length > 0
                      ? productUnsaveRawList.data
                      : []
                  }
                  scroll={scroll}
                  rowKey={(record) => record.id}
                />
                <div
                  style={{
                    display:
                      productUnsaveRawList.data.length > 0 ? "flex" : "none",
                  }}
                >
                  <div style={{ flexGrow: 1 }} />
                  <div>
                    <Button
                      type="primary"
                      loading={loadings}
                      //   htmlType="submit"
                      //   style={{ width: "100%", borderRadius: "20px" }}
                      onClick={() => setOpenDrawer(true)}
                    >
                      {loadings ? "Loading" : "Create"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
            <div style={{ padding: 10 }}>
              <div style={{ marginBottom: 10 }}>
                <Typography.Title level={4}>
                  Add To Unsave Product
                </Typography.Title>
              </div>
              <div>
                <Form
                  form={form}
                  layout="vertical"
                  name="basic"
                  initialValues={{ remember: false }}
                  onFinish={handleAddProductToUnsave}
                  autoComplete="off"
                >
                  <Space
                    direction="vertical"
                    style={{
                      width: "100%",
                      margin: 0,
                    }}
                  >
                    <Form.Item
                      name="product"
                      label="Product"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select product"
                        onChange={(e) => {
                          handleFetchProduct(e);
                        }}
                        size="large"
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {productRawList.data.length > 0 ? (
                          productRawList.data.map((data, index) => (
                            <Select.Option value={data.raw_id} key={index}>
                              {data.product}
                            </Select.Option>
                          ))
                        ) : (
                          <Select.Option value="">
                            No raw product found!
                          </Select.Option>
                        )}
                      </Select>
                    </Form.Item>

                    {specProductInfo.ready && specProductInfo.data && (
                      <>
                        <Form.Item label="Unit">
                          <Input
                            placeholder="Set firstname"
                            size="large"
                            defaultValue={
                              specProductInfo.data[0].rawproductsuserunit.unit
                            }
                            disabled
                          />
                        </Form.Item>

                        <Form.Item
                          name="consumption"
                          label="Quantity Consumption"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            value={inputedQuantityConversion}
                            size="large"
                            style={{ width: "100%" }}
                            step="1"
                            onChange={(value) => {
                              if (value === null) {
                                setInputedQuantityConversion(0);
                              } else {
                                setInputedQuantityConversion(value);
                              }
                            }}
                          />
                        </Form.Item>
                      </>
                    )}
                  </Space>

                  <Form.Item style={{ marginTop: "20px" }}>
                    <Button
                      type="primary"
                      loading={loadings}
                      htmlType="submit"
                      style={{ width: "100%", borderRadius: "20px" }}
                      disabled={parseInt(inputedQuantityConversion) === 0}
                    >
                      {loadings ? "Loading" : "Add"}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {openDrawer && (
        <SaveProductUnsave
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getProductUnsaveList={() => getProductUnsaveList()}
          getProductList={() => getProductList()}
          categoryList={categoryList}
        />
      )}

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
      />
    </>
  );
};

export default AddProductOrders;
